<template>
    <Layout
        :header="{ text: '視訊作業', backBtn: { visible: true }, closeBtn: { visible: true, to: { name: routeName.CLOUD_E_COUNTER_RESERVE_HOME} }, }"
    >

        <div class="pt-2 pb-6">
            <Process :steps="['服務條款', '查看內容', '視訊驗證', '身份認證',]" :index="1"></Process>
        </div>

        <div class="pb-4">
            <h2 class="font-bold text-2xl">
                查看預約申請內容
            </h2>
        </div>

        <h3 class="font-bold text-xl pb-2">輸入密碼</h3>
        <p class="pb-2">密碼為您的身分證字號，第一個英文字母需大寫</p>
        <input type="password" v-model="pageData.code" />

        <template v-slot:bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                :disabled="pageData.code === ''" @click="goNextPage"
            >確認
            </button>
        </template>
        <Loading
            :is-loading="pageData.isLoading"
        />
    </Layout>
</template>
<script setup>
import { reactive } from 'vue';
import Loading from '@/components/Loading.vue';
import { postCheckRecord } from '@/apis/CloudECounterReserve';
import { openPopupCatchMessage } from '@/utils/vfmUtils';
import routeName from '@/router/constant';
import { useRouter } from 'vue-router';
import '@/assets/cloudCounter/css/style.css';

import Layout from '@/components/cloudCounter/Layout.vue';
import Process from '@/components/cloudCounter/Process.vue';
import AplCatlCode from '@/json/aplCatlCode';

const router = useRouter();

const pageData = reactive(
    {
        isLoading: false,
        code: '',
        errorMessage: {
            code: '',
        },
    });
const goNextPage = () => {
    if (!pageData.code) {
        pageData.errorMessage.code = '請輸入密碼';
        return;
    } else {
        pageData.errorMessage.code = '';
    }
    pageData.isLoading = true;
    const request = {
        code: pageData.code,
    };
    postCheckRecord(request).then(res => {
        if (res.data?.aplCatlType === AplCatlCode.APPLICANT_CHANGE) {
            router.push({ name: routeName.CLOUD_E_COUNTER_RESERVE_RECORD_APPLICANT_CHANGE });
        } else if (res.data?.aplCatlType === AplCatlCode.LOAN) {
            router.push({ name: routeName.CLOUD_E_COUNTER_RESERVE_RECORD_LOAN });
        } else if (res.data?.aplCatlType === AplCatlCode.APPLICANT_INSURED_NAME_CHANGE) {
            router.push({ name: routeName.CLOUD_E_COUNTER_RESERVE_RECORD_NAME });
        } else if (res.data?.aplCatlType === AplCatlCode.BENEIFCIARY) {
            router.push({ name: routeName.CLOUD_E_COUNTER_RESERVE_RECORD_BENEFICIARY });
        }
    }).catch(ex => {
        pageData.isLoading = false;
        openPopupCatchMessage(ex);
    });
};
</script>

<style scoped lang="scss">

</style>
